import { Button, Space } from "antd";
import PrefaktorCustomerInfo from "components/prefaktorComponents/prefaktorCustomerInfo/PrefaktorCustomerInfo";
import PreFaktorPrintBody from "components/prefaktorComponents/prefaktorPrintBody/PreFaktorPrintBody";
import PreFaktorPrintFooter from "components/prefaktorComponents/prefaktorPrintFooter/PreFaktorPrintFooter";
import PreFaktorPrintHeader from "components/prefaktorComponents/prefaktorPrintHeader/PreFaktorPrintHeader";
import Loading from "layouts/Loading/Loading";
import OpenNotificationWithIcon from "layouts/notificationWithIcon/OpenNotificationWithIcon ";
import Axios from "middleware/axiosInstance";
import React, { useState } from "react";
import "./AddPrefaktorDocument.scss";
const AddPrefaktorDocument = () => {
  const [prefactorInfoToShowAndPrint, setPrefactorInfoToShowAndPrint] =
    useState(null);
  const [
    prefactorItemsInfoToShowAndPrint,
    setPrefactorItemsInfoToShowAndPrint,
  ] = useState(null);
  const [prefaktorInfo, setPrefaktorInfo] = useState(null);

  const prepareFaktorInfo = (prefaktorInfo) => {
    console.log(prefaktorInfo);
    const { people_id } = prefaktorInfo;
    console.log("people_id", people_id);
    const { items } = prefaktorInfo;
    console.log("items", items);
    const standardPrefaktorInfo = {
      people_id,
      items,
      ...(prefaktorInfo.clearingDate?.miladi && {
        clearing_date: prefaktorInfo.clearingDate.miladi,
      }),
    };
    return standardPrefaktorInfo;
  };
  const sendPreFactorToServer = async (prefaktorInfo) => {
    const prefaktor = await prepareFaktorInfo(prefaktorInfo);
    Axios.post("/invoice", prefaktor)
      .then((res) => {
        const factorId = res.data.last_id;

        Axios.get(`/invoice/${factorId}`).then((res) => {
          console.log(res.data);
          setPrefactorInfoToShowAndPrint(res.data);
        });
        Axios.get(`/invoice_items/${factorId}`).then((res) => {
          console.log(res.data);
          setPrefactorItemsInfoToShowAndPrint(res.data);
        });
      })
      .catch((err) => {
        console.log(err);
        OpenNotificationWithIcon(
          "ثبت ناموفق",
          "ثبت پیش فاکتور انجام نشد",
          "error"
        );
      });
  };

  return (
    <div className="customized-container">
      <div className="customized-wrapper">
        <h5 className="title-session d-print-none">ایجاد پیش فاکتور</h5>

        {prefaktorInfo === null ? (
          <PrefaktorCustomerInfo
            setPrefaktorInfo={setPrefaktorInfo}
            sendPreFactorToServer={sendPreFactorToServer}
          />
        ) : prefactorItemsInfoToShowAndPrint && prefactorInfoToShowAndPrint ? (
          <div className="d-print-flex flex-column">
            <PreFaktorPrintHeader prefaktorInfo={prefactorInfoToShowAndPrint} />
            <PreFaktorPrintBody
              prefaktorInfo={prefactorItemsInfoToShowAndPrint}
            />
            <PreFaktorPrintFooter />
          </div>
        ) : (
          <Loading />
        )}
            
{
  prefaktorInfo &&
        <Space wrap>
          <Button className="d-print-none mt-3" type="primary" onClick={window.print}>چاپ پیش فاکتور</Button>
        </Space>
}
      </div>
    </div>
  );
};

export default AddPrefaktorDocument;
